// packages/ui/src/auth/AuthWordmark.tsx
export interface AuthWordmarkProps {
  /** The brand name as the caller resolved it (messages, tenant branding). */
  name: string;
  /** Class for the second half, for example text-teal-200 on the panel, text-teal-600 on the bar. */
  accentClassName?: string;
}

// Two-tone wordmark: first half plain, second half in the accent. Same split as
// BrandWordmark in @test-prep/b2b-branding-client, for apps that do not depend on it.
export function AuthWordmark({ name, accentClassName }: AuthWordmarkProps) {
  const chars = Array.from(name);
  const splitAt = Math.floor(chars.length / 2);
  return (
    <>
      {chars.slice(0, splitAt).join('')}
      <span className={accentClassName}>{chars.slice(splitAt).join('')}</span>
    </>
  );
}
